import BaseService from "../BaseService";
import _ from "lodash";

class ProductCategoryService extends BaseService {
    list = async ({ info } = {}) => {
        var data = await this._api.post("/store/product_category/list", { info });
        return data;
    };





}
export default ProductCategoryService;
